
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_c0434_17",
  "full-width": "awsui_full-width_8cbea_c0434_44",
  "refresh": "awsui_refresh_8cbea_c0434_47",
  "disabled": "awsui_disabled_8cbea_c0434_53",
  "selected": "awsui_selected_8cbea_c0434_116",
  "icon": "awsui_icon_8cbea_c0434_128",
  "with-text": "awsui_with-text_8cbea_c0434_132",
  "with-no-text": "awsui_with-no-text_8cbea_c0434_141",
  "root": "awsui_root_8cbea_c0434_146",
  "segment-part": "awsui_segment-part_8cbea_c0434_178",
  "grouped": "awsui_grouped_8cbea_c0434_203",
  "grouped-only": "awsui_grouped-only_8cbea_c0434_203",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_c0434_207",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_c0434_219",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_c0434_223",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_c0434_229",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_c0434_233",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_c0434_237",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_c0434_243",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_c0434_247",
  "grouped-with-error": "awsui_grouped-with-error_8cbea_c0434_251",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_c0434_279",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_c0434_279",
  "grouped-with-warning": "awsui_grouped-with-warning_8cbea_c0434_285",
  "select": "awsui_select_8cbea_c0434_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_c0434_349",
  "segment-count-3": "awsui_segment-count-3_8cbea_c0434_356",
  "segment-count-4": "awsui_segment-count-4_8cbea_c0434_363",
  "segment-count-5": "awsui_segment-count-5_8cbea_c0434_370",
  "segment-count-6": "awsui_segment-count-6_8cbea_c0434_377",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_c0434_384"
};
  